import React from "react"
import './contactLoader.css';

const ContactLoader = () => {
    return (
        <>
            <div className="contact_loader"></div>
        </>
    )
}

export default ContactLoader